export default __webpack_public_path__ + "logo-light.fdb03fbabe19a113be19c63650aed56c.svg";